module.exports = __webpack_public_path__ + "img/benefit2.66db5abb.jpg";